<template>
    <div :id="id" class="mortgage-bond-form">
        <preloader v-show="loading"></preloader>

        <div v-if="sendedSuccess" class="form__scope _position-relative">
            <div class="mortgage-bond-form__bg mortgage-bond-form__bg_final _mobile-hidden"></div>
            <div class="_dflex _flexwrap">
                <div class="_w-480-full">
                    <div class="h2 _mb-16-8">
                        Заявка успешно отправлена
                    </div>
                    <div class="_mb-24">
                        <p class="p1">
                            Когда закладная будет готова, с Вами свяжется сотрудник/представитель Банка для подписания закладной
                        </p>
                    </div>
                    <notice-attention>
                        Срок подготовки закладной 14 рабочих дней с даты предоставления полного комплекта документов в Банк
                    </notice-attention>
                </div>
            </div>
        </div>

        <div v-if="!sendedSuccess" class="form__scope">

            <h1 class="h2 _mb-16-16">Оформление закладной по ипотеке</h1>

            <p class="p2 _mb-40-24">
                Оформите закладную, если вы купили недвижимость на этапе строительства и уже подписали с застройщиком акт приема-передачи
            </p>

            <div class="form__progress">
                <div class="form__progress-wrapper">
                    <div class="form__progress-top">
                        <div class="form__progress-steps">
                            Шаг&nbsp;{{currentStep}}&nbsp;из&nbsp;{{totalSteps}}
                        </div>
                        <div class="form__progress-action" v-html="stepsParse"></div>
                    </div>
                    <div class="form__progress-line">
                        <div class="form__progress-line__base"></div>
                        <div class="form__progress-line__ahead" :style="`width: ${progressAheadPercent}%`"></div>
                        <div class="form__progress-line__done" :style="`width: ${progressDonePercent}%`"></div>
                    </div>
                </div>
            </div>
            <template v-if="currentStep === 1">
                <div class="form__split form__split-border _pt-0 _pb-0">
                    <div class="form__split-title">
                        <div class="h3">Информация о вас</div>
                    </div>
                    <div class="form__split-fields">
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-surname`"
                                        v-model.trim.lazy="$v.contactDetails.fullName.surname.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.surname.$error, '_focus': contactDetails.fullName.surname.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="surname"
                                        @blur="$v.contactDetails.fullName.surname.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-surname`" class="form__label">Фамилия</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.surname.$error && !$v.contactDetails.fullName.surname.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.surname.$error && !$v.contactDetails.fullName.surname.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                            <div class="form__col">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-name`"
                                        v-model.trim.lazy="$v.contactDetails.fullName.name.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.name.$error, '_focus': contactDetails.fullName.name.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="name"
                                        @blur="$v.contactDetails.fullName.name.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-name`" class="form__label">Имя</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.name.$error && !$v.contactDetails.fullName.name.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.name.$error && !$v.contactDetails.fullName.name.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__input" :class="{ 'form__input-blocked': isNoPatronymic }">
                                    <input
                                        :id="`${id}-name`"
                                        v-model.trim.lazy="$v.contactDetails.fullName.patronymic.$model"
                                        :class="{ '_invalid': $v.contactDetails.fullName.patronymic.$error, '_focus': contactDetails.fullName.patronymic.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="patronymic"
                                        @blur="$v.contactDetails.fullName.patronymic.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-patronymic`" class="form__label">Отчество</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.fullName.patronymic.$error && !$v.contactDetails.fullName.patronymic.required">Это поле необходимо заполнить</p>
                                <p class="form-error" v-if="$v.contactDetails.fullName.patronymic.$error && !$v.contactDetails.fullName.patronymic.cyrWithDash">Поле не&nbsp;должно содержать латинские буквы</p>
                            </div>
                            <div class="form__col">
                                <div class="checkbox _mt-16-0 _mb-0">
                                    <input :id="`${id}-is-no-patronymic`" v-model="isNoPatronymic" type="checkbox" class="checkbox__input" name="is-no-patronymic">
                                    <label :for="`${id}-is-no-patronymic`" class="checkbox__label">
                                        <p class="p2">Нет отчества</p>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div
                                    class="form__input"
                                    :class="{
                                    'form__input-blocked': isPhoneVerivied,
                                  }"
                                >
                                    <input
                                        :id="`${id}-phone`"
                                        v-model="contactDetails.phone"
                                        v-phone
                                        v-mask="'+7 ###-###-##-##'"
                                        placeholder="+7"
                                        :class="{ '_invalid': $v.contactDetails.phone.$error, '_focus': contactDetails.phone.length > 0 }"
                                        type="tel"
                                        class="d-input _focus-always"
                                        name="phone"
                                        :disabled="isPhoneVerivied"
                                    >
                                    <label :for="`${id}-phone`" class="form__label">Телефон</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.phone.$error && !$v.contactDetails.phone.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-else-if="$v.contactDetails.phone.$error && !$v.contactDetails.phone.phoneLength || !$v.contactDetails.phone.seemsDigitInPhone">Проверьте корректность номера.</p>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-email`"
                                        v-model.trim.lazy="$v.contactDetails.email.$model"
                                        :class="{ '_invalid': $v.contactDetails.email.$error, '_focus': contactDetails.email.length > 0 }"
                                        type="email"
                                        class="d-input"
                                        name="email"
                                        @blur="$v.contactDetails.email.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-email`" class="form__label">Email</label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.email.$error && !$v.contactDetails.email.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-if="$v.contactDetails.email.$error && !$v.contactDetails.email.email">Неверный формат E-mail</p>
                            </div>
                        </div>

                        <div class="p1 _mb-8 _mt-32">СНИЛС</div>
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-snils`"
                                        v-model="contactDetails.snils"
                                        v-mask="'### ### ### ##'"
                                        :class="{ '_invalid': $v.contactDetails.snils.$error, '_focus': contactDetails.snils.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        inputmode="numeric"
                                        name="snils"
                                    >
                                    <label :for="`${id}-snils`" class="form__label">
                                        {{ contactDetails.snils.length === 0 ? 'Введите номер СНИЛС' : 'СНИЛС'}}
                                    </label>
                                </div>
                                <p class="form-error" v-if="$v.contactDetails.snils.$error && !$v.contactDetails.snils.correctSnils">Неверный формат СНИЛС</p>
                            </div>
                        </div>

                        <div class="p3 text-gray _mb-16">Или загрузите копию, если СНИЛС ранее не предоставлялся</div>
                        <form-docs-group
                            v-model="files.snils"
                            category="snils"
                            :files-max-count="1"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'snils')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>
                    </div>
                </div>
                <div class="form__split _pb-0">
                    <div class="form__split-title">
                        <div class="h3">Данные о кредите</div>
                    </div>
                    <div class="form__split-fields">
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-document-number`"
                                        v-model.trim.lazy="$v.documentNumber.$model"
                                        :class="{ '_invalid': $v.documentNumber.$error, '_focus': documentNumber.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="document-number"
                                        @blur="$v.documentNumber.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-document-number`" class="form__label">
                                        Номер кредитного договора
                                    </label>
                                </div>
                                <p class="form-error" v-if="$v.documentNumber.$error && !$v.documentNumber.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-else-if="$v.documentNumber.$error && !$v.documentNumber.validDocnumber">Недопустимые символы</p>
                            </div>
                        </div>
                        <div class="form__row _mb-0">
                            <div class="form__col _w-100">
                                <ui-form-field
                                    label="Город подписания закладной"
                                    :errors="vuelidateErrorMesages.documentCity"
                                    :value="$v.documentCity.$model"
                                    :id="`${id}-document-city`"
                                >
                                    <template v-slot:default="{ id, errors }">
                                        <UiTextInputSuggestions
                                            :id="id"
                                            v-model="$v.documentCity.$model"
                                            :suggestionType="ESuggestionTypes.ADDRESS"
                                            :bounds_from="EAddressBounds.CITY"
                                            :bounds_to="EAddressBounds.SETTLEMENT"
                                            :count="3"
                                            :error="!!errors.length"
                                            name="document-city"
                                            only-suggestion
                                            autolocation
                                        />
                                    </template>
                                </ui-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="currentStep === 2">
                <div class="form__split form__split-border _pt-0">
                    <div class="form__split-title">
                        <div class="h3">Приложите копии документов</div>
                    </div>
                    <div class="form__split-fields">
                        <div class="p1 _mb-8">Паспорт РФ</div>
                        <div class="p3 text-gray _mb-16">Приложите скан или фото: основной разворот (2-3 страница), страницы с регистрацией (5-12 страницы), сведения о ранее выданных паспортах (18-19 страница).</div>
                        <form-docs-group
                            v-model="$v.files.passport.$model"
                            category="passport"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'passport')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>
                        <p class="form-error" v-if="$v.files.passport.$error && !$v.files.passport.required">Поле обязательно для заполнения</p>

                        <div class="p1 _mb-8 _mt-32">Выписка из ЕГРН либо договор приобретения (если право собственности еще не оформлено)</div>
                        <div class="p3 text-gray _mb-16">Рекомендуем оформить право собственности до обращения в Банк для оформления закладной, в этом случае предоставляется Выписка из ЕГРН. Договор приобретения обязателен для предоставления, если право собственности на объект недвижимости еще не зарегистрировано.</div>
                        <form-docs-group
                            v-model="files.ddu"
                            category="ddu"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'ddu')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Скан-копии документов или оригинал электронного документа, подписанного электронной подписью. Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>

                        <div class="p1 _mb-8 _mt-32">Акт приема-передачи</div>
                        <div class="p3 text-gray _mb-16">Акт приема-передачи обязателен для предоставления, если право собственности на объект недвижимости еще не зарегистрировано.</div>
                        <div class="p3 text-gray _mb-16">Регистрация права собственности одновременно с электронной закладной возможна в случае предоставления акта приема-передачи недвижимости в форме электронного документа с электронными подписями застройщика и залогодателя(-ей). В остальных случаях право собственности должно быть оформлено на момент подачи документов.</div>
                        <form-docs-group
                            v-model="files.acceptanceСertificate"
                            category="acceptanceСertificate"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'acceptanceСertificate')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Скан-копии документов или оригинал электронного документа, подписанного электронной подписью. Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>

                        <div class="p1 _mb-8 _mt-32">Отчет об оценке объекта залога</div>
                        <form-docs-group
                            v-model="$v.files.evaluationReport.$model"
                            category="evaluationReport"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'evaluationReport')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Скан-копии документов или оригинал электронного документа, подписанного электронной подписью. Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>
                        <p class="form-error" v-if="$v.files.evaluationReport.$error && !$v.files.evaluationReport.required">Поле обязательно для заполнения</p>

                        <div class="p3 text-gray _mt-40 _mb-16">Введите номер отчета об оценке, оформленного в Мобильном оценщике/Банке оценщике.</div>
                        <div class="form__row">
                            <div class="form__col _w-100">
                                <div class="form__input">
                                    <input
                                        :id="`${id}-evaluation-report-number`"
                                        v-model.trim.lazy="$v.evaluationReportNumber.$model"
                                        :class="{ '_invalid': $v.evaluationReportNumber.$error, '_focus': evaluationReportNumber.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        name="evaluationReportNumber"
                                        @blur="$v.evaluationReportNumber.$model = $event.target.value.trim()"
                                    >
                                    <label :for="`${id}-evaluation-report-number`" class="form__label">
                                        Номер отчета об оценке
                                    </label>
                                </div>
                                <p class="form-error" v-if="$v.evaluationReportNumber.$error && !$v.evaluationReportNumber.required">Поле обязательно для заполнения</p>
                            </div>
                        </div>

                        <div class="p1 _mb-8 _mt-32">Технические документы по объекту (при наличии)</div>
                        <div class="p3 text-gray _mb-16">Поэтажный план и экспликация предоставляется в случае отсутствия в отчете об оценке.</div>
                        <form-docs-group
                            v-model="files.technicalDocs"
                            category="technicalDocs"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkFileDuplicates($event, 'technicalDocs')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>

                    </div>
                </div>

                <div
                    v-for="($coborrover, i) in $v.coborrowers.$each.$iter"
                    :key="i"
                    class="form__split form__split-border"
                >
                    <div class="form__split-title">
                        <div class="h3">Созаемщик {{ Number(i) + 1 }}</div>
                    </div>
                    <div class="form__split-fields">
                        <div class="p1 _mb-8">Паспорт РФ</div>
                        <div class="p3 text-gray _mb-16">Приложите скан или фото: основной разворот (2-3 страница), страницы с регистрацией (5-12 страницы), сведения о ранее выданных паспортах (18-19 страница).</div>
                        <form-docs-group
                            v-model="$coborrover.passport.$model"
                            :category="`coborrower-${i}-passport`"
                            :files-max-count="10"
                            :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                            :fileMaxSize="1536e4"
                            @input="checkCoborrowerFileDuplicates($event, i, 'passport')"
                        >
                            <template #placeholder="{ extentions, size}">
                                {{ `Файлы формата ${extentions} размером до ${size}` }}
                            </template>
                        </form-docs-group>
                        <p class="form-error" v-if="$coborrover.passport.$error && !$coborrover.passport.required">Поле обязательно для заполнения</p>

                        <div class="p1 _mb-8 _mt-32">СНИЛС</div>
                        <div class="p3 text-gray _mb-16">Введите номер СНИЛС или приложите отсканированную копию</div>
                        <div class="form__row _mt-32">
                            <div class="form__col _w-100">
                                <div
                                    class="form__input"
                                    :class="{
                                    'form__input-blocked': $coborrover.SNILS.$model.length > 0,
                                  }"
                                >
                                    <input
                                        :id="`${id}-coborrower-${i}-numSNILS`"
                                        v-model="$coborrover.numSNILS.$model"
                                        v-mask="'### ### ### ##'"
                                        inputmode="numeric"
                                        :class="{ '_invalid': $coborrover.numSNILS.$error, '_focus': $coborrover.numSNILS.$model.length > 0 }"
                                        type="text"
                                        class="d-input"
                                        :name="`coborrower-${i}-numSNILS`"
                                    >
                                    <label :for="`${id}-coborrower-${i}-numSNILS`" class="form__label">
                                        {{ $coborrover.numSNILS.$model.length === 0 ? 'Введите номер СНИЛС' : 'СНИЛС' }}
                                    </label>
                                </div>
                                <p class="form-error" v-if="$coborrover.numSNILS.$error && !$coborrover.numSNILS.required">Поле обязательно для заполнения</p>
                                <p class="form-error" v-else-if="$coborrover.numSNILS.$error && !$coborrover.numSNILS.correctSnils">Неверный формат СНИЛС</p>
                            </div>
                        </div>

                        <div class="_mb-32">
                            <form-docs-group
                                v-model="$coborrover.SNILS.$model"
                                :category="`coborrower-${i}-SNILS`"
                                :files-max-count="1"
                                :allow-formats="['pdf', 'sig', 'png', 'jpeg', 'jpg']"
                                :fileMaxSize="1536e4"
                                @input="checkCoborrowerFileDuplicates($event, i, 'SNILS')"
                            >
                                <template #placeholder="{ extentions, size}">
                                    {{ `Файлы формата ${extentions} размером до ${size}` }}
                                </template>
                            </form-docs-group>
                            <p class="form-error" v-if="$coborrover.SNILS.$error && !$coborrover.SNILS.required">Поле обязательно для заполнения</p>
                        </div>

                        <button
                            class="button button_black button_size-sm"
                            @click="onRemoveCoborrower(i)"
                        >
                            <div class="icon icon-trash-light"></div>
                            Удалить
                        </button>

                    </div>
                </div>

                <div
                    v-if="coborrowers.length < 3"
                    class="form__split form__split-border"
                >
                    <div class="form__split-title">
                        <div class="h3">Созаемщик {{ coborrowers.length > 0 ? coborrowers.length + 1 : '' }}</div>
                    </div>
                    <div class="form__split-fields">
                        <div class="p1 _mb-24">При наличии иных заемщиков/залогодателей необходимо предоставить их СНИЛС и скан-копии паспортов</div>

                        <button
                            class="button button_black button_size-sm"
                            @click="onAddCoborrower"
                        >
                            <div class="icon icon-plus-in-light"></div>
                            Добавить созаемщика
                        </button>

                    </div>
                </div>
            </template>

            <div class="form__split _pt-0 _pb-0 _mt-40">
                <div class="form__split-title _mb-0">
                    <!--  -->
                </div>
                <div class="form__split-fields">
                    <div class="_dflex _flexwrap">
                        <div
                            v-if="currentStep > 1"
                            class="button button_white _order-first _mr-24-0"
                            @click="onBack"
                        >Назад</div>
                        <div class="button button_green _order-second _mb-0-16" @click="onNext">Продолжить</div>
                    </div>
                    <div class="form__lock _mt-24-24">
                        <span class="ico ico-safety ico_color_gray-dark ico_size_16 _mr-12"></span>
                        <span class="p4 form__lock-text">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без вашего согласия на это, если иное не предусмотрено законодательством</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- modals -->
        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="contactDetails.phone"
            :endpoint="formData.data.type"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="onPhoneVerificationSuccess"
        />

        <error-modal
            :value="!!errorText"
            @input="(val) => { if (!val) { errorText = ''; } }"
        >
            {{ errorText }}
        </error-modal>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, requiredUnless, helpers } from 'vuelidate/lib/validators';
import { cyrWithDash, phoneLength, seemsDigitInPhone, correctSnils, validDocnumber } from '../../assets/js/vue/validations';
import { getSessid, scrollToElem, getErrorText } from "../../assets/js/utils";
import axios from 'axios';
import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes';
import { EAddressBounds } from '../../assets/js/vue/utlis/useDadata/utils/EAddressBounds';
import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
import vuelidateMessages from '../../assets/js/vue/validationsMessages';
import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';

class Coborrower {
    constructor(passport = [], SNILS = [], numSNILS = '') {
        this.passport = passport;
        this.SNILS = SNILS;
        this.numSNILS = numSNILS;
    }
}

export default {
    name: 'MortgageBondForm',
    mixins: [validationMixin],
    components: {
        UiTextInputSuggestions,
    },
    data() {
        return {
            id: 'mortgage-bond-form',
            contactDetails: {
                fullName: {
                    name: '',
                    surname: '',
                    patronymic: '',
                },
                phone: '',
                email: '',
                snils: '',
            },
            documentNumber: '',
            documentCity: '',
            isNoPatronymic: false,
            currentStep: 1,
            totalSteps: 2,
            loading: false,
            isPhoneVerivied: false,
            evaluationReportNumber: '',
            files: {
                passport: [],
                ddu: [],
                acceptanceСertificate: [],
                evaluationReport: [],
                technicalDocs: [],
                snils: [],
            },
            coborrowers: [],
            sendedSuccess: false,
            errorText: '',
            modalSmsShow: false,
            ESuggestionTypes,
            EAddressBounds,
        }
    },
    validations() {
        return {
            contactDetails: {
                fullName: {
                    name: { required, cyrWithDash, },
                    surname: { required, cyrWithDash, },
                    patronymic: {
                        required: this.isNoPatronymic ? () => true : required,
                        cyrWithDash,
                    },
                },
                phone: {
                    required,
                    phoneLength,
                    seemsDigitInPhone,
                },
                email: {
                    required,
                    email,
                },
                snils: {
                    correctSnils: (val) => !helpers.req(val) || correctSnils(val),
                },
            },
            documentNumber: {
                required,
                validDocnumber,
            },
            documentCity: { required },
            files: {
                passport: {
                    required,
                },
                evaluationReport: {
                    required: requiredUnless(() => this.evaluationReportNumber.length > 0)
                },
            },
            coborrowers: {
                $each: {
                    passport: { required },
                    SNILS: { required: requiredUnless((val) => val.numSNILS.length > 0) },
                    numSNILS: {
                        required: requiredUnless((val) => val.SNILS.length > 0),
                        correctSnils: (val, coborrover) => {
                            return coborrover.SNILS.length > 0 || correctSnils(val);
                        },
                    },
                },
            },
            evaluationReportNumber: {
                required: requiredUnless(() => this.files.evaluationReport.length > 0),
            },
        };
    },
    computed: {
        progressAheadPercent() {
            return (this.currentStep / this.totalSteps) * 100;
        },
        progressDonePercent() {
            return (this.currentStep / this.totalSteps) * 100 - (1 / this.totalSteps) * 100;
        },
        stepsParse() {
            let res = '';
            switch(this.currentStep) {
                case 1: res = 'Заполните личные данные'; break;
                case 2: res = 'Выберите место и <br class="_mobile-visible">время встречи'; break;
                case 3: res = 'Пройдите идентификацию'; break;
            }
            return res;
        },
        formData() {
            return {
                data: {
                    type: 'encumbranceApplication',
                    attributes: {
                        phone: this.contactDetails.phone.replaceAll(/[^\d]/g, ''),
                        contactDetails: {
                            ...this.contactDetails,
                            snils: this.contactDetails.snils.replaceAll(/[^\d]/g, ''),
                        },
                        documentNumber: this.documentNumber,
                        documentCity: this.documentCity,
                        evaluationReportNumber: this.evaluationReportNumber,
                    },
                    files: Object.entries(this.files).reduce((acc, [type, files]) => {

                        acc.push(...files.map((file) => ({
                            type,
                            name: file.name,
                            content: file.base64,
                            contentType: 'multipart/form-data',
                        })));

                        return acc;
                    }, []),
                    coborrowers: this.coborrowers.map((coborrower) => {
                        const result = {
                            passport: coborrower.passport.map((passport) => ({
                                type: 'passport',
                                name: passport.name,
                                content: passport.base64,
                                contentType: 'multipart/form-data',
                            })),
                        };

                        if (coborrower.SNILS.length > 0) {
                            result.SNILS = coborrower.SNILS.map((snils) => ({
                                type: 'SNILS',
                                name: snils.name,
                                content: snils.base64,
                                contentType: 'multipart/form-data',
                            }));
                        } else {
                            result.numSNILS = coborrower.numSNILS.replaceAll(/[^\d]/g, '');
                        }

                        return result;
                    }),
                },
            };
        },
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
        },
    },
    methods: {
        /**
         * Находим индексы в `newFiles` файлов, с файлами из списка
         * `files`, совпадающих по `comparator`
         */
         getIdIntersectionWith(newFiles, files, comparator) {
            let indexesToDelete = [];

            for (let i = 0; i < newFiles.length; i++) {
                const newFile = newFiles[i];

                if (files.some((item) => comparator(item, newFile))) {
                    indexesToDelete.push(i);
                }
            }

            return indexesToDelete;
        },
        /**
         * Возвращает плоский списков файлов из `this.files` исключая из объекта `keyNew`
         * @param {string} keyNew - ключ поля
         */
        getFileDuplicates(keyNew) {
            return Object.entries(this.files).reduce((acc, [key, val]) => {
                if (key === keyNew) return acc;
                acc.push(...val);
                return acc;
            }, []);
        },
        /**
         * Возвращает плоский списков файлов из `this.coborrowers` исключая из объекта `indexNew + keyNew`
         * @param {number} indexNew - индекс созаемщика
         * @param {string} keyNew - ключ поля
         */
        getCoborrowerFileDuplicates(indexNew, keyNew) {
            return this.coborrowers.reduce((acc, cur, i) => {
                Object.entries(cur).forEach(([key, val]) => {
                    if (!(i === indexNew && key === keyNew) && Array.isArray(val)) acc.push(...val);
                });
                return acc;
            }, []);
        },
        checkFileDuplicates(newFiles, keyNew) {
            const files = this.getFileDuplicates(keyNew);
            files.push(...this.getCoborrowerFileDuplicates());

            const indexesOfEqualNameAndSize = this.getIdIntersectionWith(newFiles, files, (a, b) => a.file.name.toLowerCase() === b.file.name.toLowerCase() && a.file.size === b.file.size);
            const indexesToDelete = this.getIdIntersectionWith(newFiles, files, (a, b) => a.file.name.toLowerCase() === b.file.name.toLowerCase());

            const hasSameNamedFiles = indexesToDelete > indexesOfEqualNameAndSize;

            indexesToDelete.forEach((i) => {
                this.files[keyNew].splice(i, 1);
            });

            if (indexesToDelete.length > 0) this.errorText = hasSameNamedFiles ? 'Вы уже загружали файл с таким названием. Пожалуйста, переименуйте файл' : 'Вы уже загружали выбранный файл';
        },
        checkCoborrowerFileDuplicates(newFiles, indexNew, keyNew) {
            const files = this.getCoborrowerFileDuplicates(Number(indexNew), keyNew);
            files.push(...this.getFileDuplicates());

            const indexesOfEqualNameAndSize = this.getIdIntersectionWith(newFiles, files, (a, b) => a.file.name.toLowerCase() === b.file.name.toLowerCase() && a.file.size === b.file.size);
            const indexesToDelete = this.getIdIntersectionWith(newFiles, files, (a, b) => a.file.name.toLowerCase() === b.file.name.toLowerCase());

            const hasSameNamedFiles = indexesToDelete > indexesOfEqualNameAndSize;

            indexesToDelete.forEach((i) => {
                this.coborrowers[indexNew][keyNew].splice(i, 1);
            });

            if (indexesToDelete.length > 0) this.errorText = hasSameNamedFiles ? 'Вы уже загружали файл с таким названием. Пожалуйста, переименуйте файл' : 'Вы уже загружали выбранный файл';
        },
        async sendForm() {
            this.loading = true;

            return axios.post('/rest/v1/addMortgageBond?sessid=' + window.config.bitrix_sessid, this.formData)
                .finally(() => {
                    this.loading = false;
                });
        },
        checkHasErrorsStep1() {
            this.$v.contactDetails.$touch();
            this.$v.documentNumber.$touch();
            this.$v.documentCity.$touch();

            const hasError = this.$v.contactDetails.$error || this.$v.documentNumber.$error || this.$v.documentCity.$error;

            if (hasError) this.scrollToFirstError();

            return hasError;
        },
        checkHasErrorsStep2() {
            this.$v.files.$touch();
            this.$v.coborrowers.$touch();
            this.$v.evaluationReportNumber.$touch();

            const hasError = this.$v.files.$error || this.$v.coborrowers.$error;

            if (hasError) this.scrollToFirstError();

            return hasError;
        },
        async scrollToFirstError() {
            await this.$nextTick();
            const topElement = Array.from(document.querySelectorAll('.form-error')).reduce((acc, item) => {
                if (!item.previousElementSibling) return acc;

                const inputElRect = item.previousElementSibling?.getBoundingClientRect();

                return acc.top < inputElRect?.top ? acc : { el: item.previousElementSibling, top: inputElRect.top};
            }, {});

            if (topElement.el) scrollToElem(topElement.el);
        },
        onBack() {
            if (this.currentStep > 1) this.currentStep--;
        },
        async onNext() {
            switch (this.currentStep) {
                case 1:
                    if (!this.checkHasErrorsStep1()) {
                        if (this.isPhoneVerivied) {
                            this.currentStep++;
                            this.scrollToTop();
                        } else {
                            this.modalSmsShow = true;
                        }
                    }
                    break;
                case 2:
                    if (!this.checkHasErrorsStep2()) {

                        await this.sendForm()
                            .then(() => {
                                this.sendedSuccess = true;
                                this.scrollToTop();
                            })
                            .catch(async (e) => {
                                // требуется повторное подтверждение номера через смс
                                if (e.response.data?.errors?.some((item) => item.status === 403)) {
                                    this.modalSmsShow = true;
                                // ИЛИ протухла сессия
                                } else if (e.response.data?.errors?.some((item) => item.status === 419)) {
                                    const res = await getSessid();
                                    window.config.bitrix_sessid = res.data;
                                    this.modalSmsShow = true;
                                } else if (e.response.data?.errors?.some((item) => item.status === 429)) {
                                    this.$modal.show('tooManyRequests');
                                } else {
                                    this.errorText = getErrorText(e);
                                }
                            });
                    }
                    break;
                default:
                    break;
            }
        },
        onPhoneVerificationSuccess() {
            this.isPhoneVerivied = true;
            this.onNext();
        },
        onAddCoborrower() {
            if (this.coborrowers.length < 3) this.coborrowers.push(new Coborrower());
        },
        onRemoveCoborrower(index) {
            this.coborrowers.splice(index, 1);
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    },
}
</script>
<style lang="scss">
@import "/local/templates/redesign/src/assets/scss/base/_variables.scss";
@import "/local/templates/redesign/src/assets/scss/base/_functions.scss";
@import "/local/templates/redesign/src/assets/scss/base/_mixins.scss";

.mortgage-bond-form {
    &__bg {
        position: absolute;
        pointer-events: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &_final {
            @include fluid('--width', 486px);
            @include fluid('--height', 339px);

            background: top right / var(--width) var(--height) no-repeat url('/local/templates/redesign/src/assets/img/mortgage/bond/final-banner.png');
        }
    }
}
</style>
